/**
 * plugins/vuetify.js
 *
 * Framework documentation: https://vuetifyjs.com`
 */

// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Composables
import { createVuetify } from 'vuetify'
// import colors from 'vuetify/util/colors'

// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
export default createVuetify({
    defaults: {
        global: {
            density: "comfortable"
        },
        VRow: {
            dense: true
        },
        VTextarea: {
            variant: "outlined",
            density: "compact",
        },
        VTextField: {
            variant: "outlined",
            density: "compact"
        },
        VBtn: {
            density: "default",
            rounded:"lg"
        },
        VSelect: {
            variant: "outlined",
            density: "compact"
        },
        VCombobox: {
            variant: "outlined",
            density: "compact"
        }
    },
    theme: {
        defaultTheme: 'light',
        // themes: {
        //     dark: {
        //         colors: {
        //             primary: colors.red.base,
        //             'surface-bright': colors.red.base
        //         },
        //         variables: {
        //             'border-color': colors.green.base,
        //             'border-opacity': 1,
        //             'button-border-color': colors.green.base
        //         }

                
        //     }
        // }
    }
}
)
